<template>
  <div
    class="d-flex align-items-center qty-block justify-content-center o-hidden"
  >
    <span class="button deduct mr5" @click="decrement"></span>
    <input
      type="text"
      class="form-control webform-control qty-value mb0 text-center"
      v-bind="$attrs"
      v-model="value"
      @input="onInput"
    />
    <span class="button add ml5" @click="increment"></span>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  data() {
    return {
      value: this.$attrs.value
    };
  },
  watch: {
    "$attrs.value": function(newVal) {
      this.value = newVal;
    }
  },
  methods: {
    decrement() {
      const min = this.$attrs.min;
      if (typeof min === "number" && this.value - 1 < min) {
        this.$toasted.show("Minimum quantity is " + min, {
          icon: { name: "fa-times" }
        });
        return;
      }

      --this.value;
      this.onInput();
    },
    increment() {
      const max = this.$attrs.max;

      if (typeof max === "number" && this.value + 1 > max) {
        this.$toasted.show("Maximum quantity is " + max, {
          icon: { name: "fa-times" }
        });
        return;
      }

      ++this.value;
      this.onInput();
    },
    onInput(event = null) {
      if (event) {
        this.$emit("input", event.target.value);
      } else {
        this.$emit("input", this.value);
      }
    }
  }
};
</script>
